import React, { useEffect, useState } from 'react';
import { Col, Row } from 'antd';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { BaseBreadcrumb } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { useNavigate } from 'react-router-dom';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import ExportTable from '@app/components/apps/Export/ExportTable';

const AllExport: React.FC = () => {
  const { setBreadcrumb, addHeaderButton, removeHeaderButton, clearHeaderButtons } = useHeader();
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const userType = user?.usertype;

  function handleCreateClick(): void {
    navigate('/add-export');
  }

  useEffect(() => {
    setBreadcrumb(
      <BaseBreadcrumb routes={[{ path: '/export', breadcrumbName: 'Export' }]} style={{ marginBottom: '15px' }} />,
    );

    {
      userType !== 'ADMIN' &&
        addHeaderButton(
          'Add Export',
          <BaseButton type="primary" size="small" onClick={handleCreateClick}>
            Create
          </BaseButton>,
        );
    }

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, []);

  return (
    <>
      <PageTitle>Export</PageTitle>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <ExportTable />
        </Col>
      </Row>
    </>
  );
};

export default AllExport;
